// @flow

import * as React from 'react';
import { isBrowser } from 'react-device-detect';

const getOffset = element => {
  const offset = ({ top, left }, { offsetTop = 0, offsetLeft = 0, offsetParent }) => {
    const output = { top: top + offsetTop, left: left + offsetLeft };

    // $FlowFixMe
    return offsetParent ? offset({ ...output }, offsetParent) : output;
  };

  return offset({ top: 0, left: 0 }, element);
};

const detectInview = () => {
  if (window.innerWidth > 992) {
    let h = window.innerHeight;
    let scrollTop = window.pageYOffset;
    let items = document.querySelectorAll('.img-cover');
    const header = document.querySelector('#header');
    // $FlowFixMe
    const headerHeight = header.offsetHeight;

    for (let i = 0; i < items.length; i++) {
      let el = items[i];

      if (getOffset(el).top - h <= scrollTop && scrollTop <= getOffset(el).top + el.clientHeight) {
        el.classList.add('inview');
      }
    }

    if (scrollTop > headerHeight) {
      // $FlowFixMe
      document.querySelector('#nav-toggle').classList.add('show');
      // $FlowFixMe
      document.querySelector('.btn-menu').classList.add('phone');
    } else {
      // $FlowFixMe
      document.querySelector('#nav-toggle').classList.remove('show');
      // $FlowFixMe
      document.querySelector('.btn-menu').classList.remove('phone');
    }
  }
};

type Props = {
  children: React.Node,
};

class DetectInViewWrapper extends React.Component<Props> {
  componentDidMount = () => isBrowser && window.addEventListener('scroll', () => detectInview());

  componentWillUnmount = () => isBrowser && window.removeEventListener('scroll', () => detectInview());

  render() {
    return <React.Fragment>{this.props.children}</React.Fragment>;
  }
}

export default DetectInViewWrapper;



// WEBPACK FOOTER //
// ./src/helpers/DetectInViewWrapper/index.js